import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CasLoginService} from '@balrog/core';
import {JhiLanguageService} from 'ng-jhipster';

@Component({
    selector: 'jhi-error',
    templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {
    errorMessage: string;
    error403: boolean;

    constructor(
        private route: ActivatedRoute,
        private languageService: JhiLanguageService,
        private loginService: CasLoginService
    ) {
    }

    ngOnInit() {
        if (!this.languageService.currentLang) {
            this.languageService.init();
        }
        this.route.data.subscribe((routeData) => {
            if (routeData.error403) {
                this.error403 = routeData.error403;
            }
            if (routeData.errorMessage) {
                this.errorMessage = routeData.errorMessage;
            }
        });
    }

    logout() {
        this.loginService.logout();
    }
}
